import DesktopMenu from "./DesktopMenu";
import MobileMenu from "./MobileMenu";

const HeaderWrapper = () => {

    return <nav className="navbar navbar-expand-lg header-dice h-lg-unset w-100 p-0">
        <MobileMenu/>
        <DesktopMenu/>
    </nav>
}

export {HeaderWrapper};